import * as React from 'react';
import { View,TouchableOpacity, ScrollView, Text, Image, Linking, Alert} from 'react-native';
export default class MsgPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount(){
  
    }
   
    render() {
        return (
          <View style={{width:"100%", height: 70, minHeight: 70, backgroundColor: "#b13335", padding: 16}}>
              <Text style={{color: 'white', fontWeight: "bolder"}}>
                 ⚠  Adicione as cartelas no carrinho e valide nas opções abaixo. Confirme o pagamento das cartelas validadas em minhas cartelas.
              </Text>
          </View>
        )
    }
}
